import Carousel from 'react-bootstrap/Carousel';
import Foto1 from '../../../assets/images/router-config.png';

import './styles.css'; // Certifique-se de importar seu CSS personalizado
import Problematica from './Problematica/Problematica';
import Demanda from './Demanda/Demanda';
import Problemas from './Problemas/Problemas';
import Custo from './Custo/Custo';
import Qualificacao from './Qualificacao/Qualificacao';
import Planejamento from './Planejamento/Planejamento';
import Ferramentas from './Ferramentas/Ferramentas';
import Tecnologias from './Tecnologias/Tecnologias';
import QoS from './QoS/QoS';
import Mesh from './Mesh/Mesh';
import Wifi6 from './Wifi6/Wifi6';
import Wifi62 from './Wifi62/Wifi62';
import FontesPesquisa from './Fontes/FontesPesquisa';
import ConclusaoPalestra from './ConclusaoPalestra/ConclusaoPalestra';
import Footer from '../../../components/Footer';
import Logomarca from '../../../assets/images/logoGiga.png';


function DarkVariantExample() {
  return (
    <>
      <div className='carousel'>
        <Carousel data-bs-theme="light" interval={null} controls={true} className="custom-carousel">
          <Carousel.Item>
            <Problematica />            
          </Carousel.Item>

          <Carousel.Item>
            <Demanda />            
          </Carousel.Item>

          <Carousel.Item>
            <Problemas />            
          </Carousel.Item>
          
          <Carousel.Item>
            <Custo />
          </Carousel.Item>

          <Carousel.Item>
            <Qualificacao />
          </Carousel.Item>

          <Carousel.Item>
            <Planejamento />
          </Carousel.Item>

          <Carousel.Item>
            <Ferramentas />
          </Carousel.Item>

          <Carousel.Item>
            <Tecnologias />
          </Carousel.Item>

          <Carousel.Item>
            <QoS />
          </Carousel.Item>  

          <Carousel.Item>
            <Mesh />
          </Carousel.Item>

          <Carousel.Item>
            <Wifi6 />
          </Carousel.Item>

          <Carousel.Item>
            <Wifi62 />
          </Carousel.Item>

          <Carousel.Item>
            <ConclusaoPalestra />
          </Carousel.Item>  

          <Carousel.Item>
            <FontesPesquisa />
          </Carousel.Item>       
        </Carousel>
        
        {/* <Footer /> */}
      </div>


    </>
  );
}

export default DarkVariantExample;
